import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

// Inputs (set by caller via dialogRef.componentInstance):
//   event              — the event template being booked (required)
//   prefill            — optional normalized record fields (name/email/phone/timezone)
//                        from YeehroCalendlyBookingService.resolveRecordPrefill
//   relatedRecord      — optional CRM record tied to the booking
//   recordType         — 'leads' | 'contacts' | 'subs' | 'providers' — matches relatedRecord
//   bookingToReschedule — optional booking record. Null = create mode (default,
//                         existing behavior unchanged). When set, the dialog
//                         flips to reschedule mode (different prefill source,
//                         former-time header, submit calls update + reschedule
//                         notification instead of create + booking confirmations).
@Component({
  selector: 'booking-internal-dialog',
  templateUrl: './booking-internal-dialog.component.html',
  styleUrls: ['./booking-internal-dialog.component.scss'],
  standalone: false
})
export class BookingInternalDialogComponent {
  event: any = null;
  prefill: any = null;
  relatedRecord: any = null;
  recordType: string = '';
  bookingToReschedule: any = null;


  constructor(private _dialogRef: MatDialogRef<BookingInternalDialogComponent>) {}


  onBookingComplete(result: any) {
    try {
      this._dialogRef?.close(result);
    } catch (err) {
      console.log('Error closing internal booking dialog: ', err);
    }
  }


  onCancelled() {
    try {
      this._dialogRef?.close();
    } catch (err) {
      console.log('Error closing internal booking dialog: ', err);
    }
  }
}
